import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ads-note"
}
const _hoisted_2 = {
  key: 1,
  class: "ads-problem"
}
const _hoisted_3 = {
  key: 2,
  class: "ads-problem"
}
const _hoisted_4 = { class: "ads-grid" }
const _hoisted_5 = { class: "ads-field" }
const _hoisted_6 = { class: "ads-row" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "ads-meter",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  key: 0,
  class: "ads-help"
}
const _hoisted_11 = {
  key: 1,
  class: "ads-help"
}
const _hoisted_12 = { class: "ads-field" }
const _hoisted_13 = { class: "ads-row" }
const _hoisted_14 = ["value", "disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ads-field" }
const _hoisted_17 = { class: "ads-row" }
const _hoisted_18 = ["value", "disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 3,
  class: "ads-note"
}

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import Swal from 'sweetalert2'
import {
  effectiveDevices, missingDevices, playTestSound, refreshDevices, setDeviceChoice, startMicTest, supportsOutputSelection,
  useAudioDevices,
} from '@/composables/useAudioDevices'


export default /*@__PURE__*/_defineComponent({
  __name: 'AudioDeviceSettings',
  props: {
    compact: { type: Boolean },
    callActive: { type: Boolean }
  },
  setup(__props: any) {

// Escolher e testar os dispositivos de áudio do telefone no navegador (useAudioDevices.ts). Usado no painel do
// telefone (PhoneWidget.vue, engrenagem) e em Admin › Linkus — lá funciona mesmo com o Linkus desligado, pra deixar
// o computador pré-configurado. A escolha fica neste navegador.


const { devices } = useAudioDevices()
const micTesting = ref(false)
const micLevel = ref(0)
let stopMic: (() => void) | null = null

const missingText = computed(() => {
  const list = missingDevices.value
  return list.length === 1 ? `O ${list[0]} escolhido não está conectado` : `Não estão conectados: ${list.join(', ')}`
})

async function allowDevices() { await refreshDevices(true) }

function pick(key: 'microphoneId' | 'speakerId' | 'ringerId', e: Event) {
  setDeviceChoice({ [key]: (e.target as HTMLSelectElement).value })
  if (key === 'microphoneId' && micTesting.value) { stopMicTest(); void toggleMicTest() }
}

async function toggleMicTest() {
  if (micTesting.value) { stopMicTest(); return }
  try {
    stopMic = await startMicTest(effectiveDevices.value.microphoneId, level => { micLevel.value = level })
    micTesting.value = true
    if (!devices.labelsVisible) void refreshDevices()
  } catch {
    Swal.fire({ icon: 'warning', title: 'Microfone não liberado', text: 'Permita o microfone pra este site e tente de novo.' })
  }
}
function stopMicTest() {
  stopMic?.()
  stopMic = null
  micTesting.value = false
  micLevel.value = 0
}
function testOutput(key: 'speakerId' | 'ringerId') {
  void playTestSound(effectiveDevices.value[key], key === 'ringerId' ? 'ring' : 'tone')
}

onMounted(() => { void refreshDevices() })
onBeforeUnmount(stopMicTest)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ads", { 'ads--compact': __props.compact }])
  }, [
    (!_unref(devices).labelsVisible)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _cache[5] || (_cache[5] = _createTextVNode(" O navegador só mostra o nome dos dispositivos depois de liberar o microfone. ", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "ads-link",
            onClick: allowDevices
          }, "Liberar e listar")
        ]))
      : _createCommentVNode("", true),
    (_unref(devices).problem)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(devices).problem), 1))
      : _createCommentVNode("", true),
    (_unref(missingDevices).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(missingText.value) + " — usando o padrão do sistema até reconectar.", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ads-label" }, "Microfone", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("select", {
            class: "ads-select",
            value: _unref(devices).choice.microphoneId,
            "aria-label": "Microfone",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (pick('microphoneId', $event)))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Padrão do sistema", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devices).inputs, (d) => {
              return (_openBlock(), _createElementBlock("option", {
                key: d.id,
                value: d.id
              }, _toDisplayString(d.label), 9, _hoisted_8))
            }), 128))
          ], 40, _hoisted_7),
          _createElementVNode("button", {
            type: "button",
            class: "ads-btn",
            onClick: toggleMicTest
          }, _toDisplayString(micTesting.value ? 'Parar' : 'Testar'), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            style: _normalizeStyle({ width: `${Math.round(micLevel.value * 100)}%` })
          }, null, 4)
        ]),
        (micTesting.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Fale alguma coisa: a barra tem que mexer."))
          : (__props.callActive)
            ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Trocar agora vale a partir da próxima ligação."))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ads-label" }, "Saída da conversa", -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("select", {
            class: "ads-select",
            value: _unref(devices).choice.speakerId,
            disabled: !_unref(supportsOutputSelection),
            "aria-label": "Saída da conversa",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (pick('speakerId', $event)))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "Padrão do sistema", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devices).outputs, (d) => {
              return (_openBlock(), _createElementBlock("option", {
                key: d.id,
                value: d.id
              }, _toDisplayString(d.label), 9, _hoisted_15))
            }), 128))
          ], 40, _hoisted_14),
          _createElementVNode("button", {
            type: "button",
            class: "ads-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (testOutput('speakerId')))
          }, "Testar")
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("small", { class: "ads-help" }, "Onde sai a voz do contato.", -1))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ads-label" }, "Saída do toque", -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("select", {
            class: "ads-select",
            value: _unref(devices).choice.ringerId,
            disabled: !_unref(supportsOutputSelection),
            "aria-label": "Saída do toque",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (pick('ringerId', $event)))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Padrão do sistema", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devices).outputs, (d) => {
              return (_openBlock(), _createElementBlock("option", {
                key: d.id,
                value: d.id
              }, _toDisplayString(d.label), 9, _hoisted_19))
            }), 128))
          ], 40, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            class: "ads-btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (testOutput('ringerId')))
          }, "Testar")
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("small", { class: "ads-help" }, "Ex.: o toque nas caixas de som e a conversa no headset.", -1))
      ])
    ]),
    (!_unref(supportsOutputSelection))
      ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Este navegador não deixa escolher a saída de áudio — o som sai no padrão do sistema. No Chrome ou no Edge dá. "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})